/* eslint-disable */
/* eslint-disable prettier/prettier */
/**
 * PS_DAF_1.0
 * import the neccassary files, packages
 * PS_DAF_1.2
 */
import moment from 'moment';
import CONSTANTS from '../constants/constant';
import { MenuConfig, SessionStoreDetails } from '../interface/paymentInfoInterface';
import i18n from '../../i18next';

/**
 * PS_DAF_1.56
 * Retrieves the store timezone from session storage.
 * Decodes the base64-encoded storeDetails from sessionStorage
 * and returns the storeTimezone field if it exists and is valid,
 * otherwise falls back to 'America/Chicago'.
 */
export function getStoreTimezone(): string {
  try {
    const storeDetailsBase64: string | null = sessionStorage.getItem(CONSTANTS.STORE_DETAILS);
    if (storeDetailsBase64) {
      const storeDetails: SessionStoreDetails = JSON.parse(Buffer.from(storeDetailsBase64, 'base64').toString('utf-8'));
      if (storeDetails.storeTimezone && isValidTimezone(storeDetails.storeTimezone)) {
        console.log('getStoreTimezone: using storeTimezone from session -', storeDetails.storeTimezone);
        return storeDetails.storeTimezone;
      }
      console.log('getStoreTimezone: storeTimezone missing or invalid, falling back to America/Chicago');
    }
  } catch (e) {
    console.error('getStoreTimezone: Error parsing storeDetails from session storage', e);
  }
  console.log('getStoreTimezone: defaulting to America/Chicago');
  return CONSTANTS.AMERCIAN_CHICAGO;
}

/**
 * PS_DAF_1.58
 * Validates whether the given string is a valid IANA timezone.
 * @param timezone - timezone string to validate
 */
function isValidTimezone(timezone: string): boolean {
  try {
    Intl.DateTimeFormat(undefined, { timeZone: timezone });
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * PS_DAF_1.3
 * @param schedule
 * @returns schedule
 * THis function returns the schedule
 * PS_DAF_1.12
 */
export function schedule(schedule: string) {
  const semi = schedule?.includes(CONSTANTS.SEMI) ? CONSTANTS.SEMI : schedule;
  switch (semi) {
    case CONSTANTS.WK:
      return i18n.t(CONSTANTS.WEEKLY);
    case CONSTANTS.BIWK:
      return i18n.t(CONSTANTS.BI_WEEKLY);
    case CONSTANTS.MON:
      return i18n.t(CONSTANTS.MONTHLY);
    case CONSTANTS.SEMI:
      return i18n.t(CONSTANTS.SEMI_MONTHLY);
    default:
      return CONSTANTS.EMPTY_STRING;
  }
}

/**
 * PS_DAF_1.13
 * @param date
 * @param format
 * This function formats the date
 * @returns date
 * PS_DAF_1.16
 */
//Need to add format type in all places this fuction invokes
export function dateFormat(date: string | Date | undefined, format: string) {
  if (date == CONSTANTS.HYPHEN || date == CONSTANTS.EMPTY_STRING) return date;
  else return moment(date).format(format);
}
export function separateDay(
  actualDate: string | Date | undefined,
  fullDayVal?: string
) {
  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const fullDays = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ];
  // console.log(actualDate,'actualDate');
  if (
    actualDate == CONSTANTS.HYPHEN ||
    actualDate == CONSTANTS.EMPTY_STRING ||
    !actualDate
  )
    return actualDate;
  const today = new Date(actualDate);
  if (fullDayVal == 'FullDay') {
    return fullDays[today.getDay()];
  } else {
    return days[today.getDay()];
  }
}
export function formatPreMaskedDateByCountry(maskedDateString, countryCode) {
  if (!maskedDateString) {
    return '';
  }
  const parts = maskedDateString.split('-');
  // if (parts.length !== 3) {
  //   return "";
  //   // }
  const month = parts[1];
  const day = parts[2];
  const maskedYear = parts[0];
  if (!month || !day) {
      return "";
  }
  const country = (countryCode || "").toUpperCase();
  if (country === "MX") {
    return `${day}/${month}/${"****"}`;
  } else {
    return `${month}/${day}/${"****"}`;
  }
}

/**
 * PS_DAF_1.17
 * @param date
 * @returns date
 * This function formats the date without the day
 * PS_DAF_1.20
 */
export function dateFormatWithoutDay(date: string) {
  return date ? moment(date).format(CONSTANTS.MM_DD_YYYY) : null;
}

/**
 * PS_DAF_1.21
 * @param desc
 * @param size
 * @returns ellipsis
 * PS_DAF_1.24
 */
export function ellipsisFormat(desc: string, size: number) {
  return desc?.length > size
    ? desc?.substring(0, size) + CONSTANTS.ELLIPSIS
    : desc;
}

/**
 * PS_DAF_1.25
 * @param bestTime
 * @returns Best Time
 * PS_DAF_1.30
 */
export function bestTimeFormat(bestTime: string) {
  //Need to check with the return words (MORN, AFTR, EVEN)
  switch (bestTime) {
    case CONSTANTS.CALL_IN_MORNING:
      return CONSTANTS.MORN;
    case CONSTANTS.CALL_IN_EVENING:
      return CONSTANTS.EVEN;
    case CONSTANTS.CALL_IN_AFTERNOON:
      return CONSTANTS.AFTN;
  }
}

/**
 * PS_DAF_1.31
 * @param multipleStoreNumber
 * @returns formatted store number
 * PS_DAF_1.35
 */
export function storeNumberFormat(multipleStoreNumber: string[]) {
  const formattedStoreNumber = multipleStoreNumber.join(',');
  return formattedStoreNumber.length > 15
    ? formattedStoreNumber.substring(0, 15) + CONSTANTS.ELLIPSIS
    : formattedStoreNumber;
}

/**
 * PS_DAF_1.36
 * @param amount
 * @param tax
 * @returns
 * PS_DAF_1.38
 */
export function totalDueAmount(amount: string, tax: string) {
  const totalTax = parseFloat(tax.replace(/,/g, ''));
  const totalAmount = parseFloat(amount.replace(/,/g, ''));
  return Number(totalAmount) + Number(totalTax);
}

/**
 * PS_DAF_1.39
 * @param menuConfig
 * @returns cash payment
 * PS_DAF_1.42
 */
export const validateCashPayment = (menuConfig: MenuConfig[]) => {
  return !menuConfig.some(
    (item: MenuConfig) =>
      item.appComponentFunctionName == CONSTANTS.CASH_PAYMENT && item.edit == 1
  );
};

/**
 * PS_DAF_1.43
 * @param splitData
 * @param splitKey
 * @returns splited key
 * PS_DAF_1.44
 */
export const splitMethod = (splitData: string, splitKey: string) => {
  return splitData.split(splitKey);
};

/**
 * PS_DAF_1.45
 * @param dueDate
 * @returns duedate
 * PS_DAF_1.55
 *
 * ❌ DO NOT USE THIS FUNCTION ANYMORE — DEPRECATED ❌
 * ❌ The name "dueDateFormat" is misleading: it does NOT format a date,
 *    it normalizes final-payment type codes (EPO/INEPO/INAGMEPO → EPO, etc.).
 * ✅ USE `getFinalPaymentType` INSTEAD (defined right below this function).
 * ✅ For any new code : import and call `getFinalPaymentType`.
 * 🚫 Kept only for backward compatibility with existing callers.
 */
export const dueDateFormat = (dueDate: string) => {
  switch (dueDate) {
    case CONSTANTS.EPO:
    case CONSTANTS.INEPO:
    case CONSTANTS.INAGMEPO:
      return CONSTANTS.EPO;

    case CONSTANTS.PIF:
    case CONSTANTS.INPIF:
      return CONSTANTS.PIF;

    case CONSTANTS.SAC:
    case CONSTANTS.INSAC:
    case CONSTANTS.INAGMSAC:
      return CONSTANTS.SAC;

    default:
      return dueDate;
  }
};

/**
 * ✅ USE THIS FUNCTION — replacement for the deprecated `dueDateFormat`.
 * Normalizes the various final-payment type codes to their canonical value:
 *   EPO / INEPO / INAGMEPO  → EPO
 *   PIF / INPIF             → PIF
 *   SAC / INSAC / INAGMSAC  → SAC
 * Any other value is returned unchanged.
 * @param finalPaymentType - the raw final-payment type code
 * @returns the canonical final-payment type (EPO | PIF | SAC) or the original value
 */
export const getFinalPaymentType = (finalPaymentType: string) => {
  switch (finalPaymentType) {
    case CONSTANTS.EPO:
    case CONSTANTS.INEPO:
    case CONSTANTS.INAGMEPO:
      return CONSTANTS.EPO;

    case CONSTANTS.PIF:
    case CONSTANTS.INPIF:
      return CONSTANTS.PIF;

    case CONSTANTS.SAC:
    case CONSTANTS.INSAC:
    case CONSTANTS.INAGMSAC:
      return CONSTANTS.SAC;

    default:
      return finalPaymentType;
  }
};


export const primaryPhoneFormat = (input: any) => {
  const cleaned = ('' + input).replace(/\D/g, '');
  const PhoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

  return cleaned.replace(PhoneRegex, '($1) $2-$3');
};

export const reduceMethod = (
  array,
  condition1: string,
  condition2: string,
  key: string
) => {
  return array?.reduce(
    (acc: number, item) =>
      acc +
      Number(
        item[condition1] == condition2 ? item[key] : CONSTANTS.ZERO_NUMBER
      ),
    CONSTANTS.ZERO_NUMBER
  );
};
